<mat-toolbar *ngIf="(runningInPortal$ | async) === false && (runningInIFrame$ | async) === false">
  <span class="standalone-toolbar-spacer"></span>
  <button mat-icon-button tabindex="-1" (click)="doLogout()">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>

<app-activity-display></app-activity-display>

<div class="content-outlet" [ngClass]="{runningInPortal: runningInPortal$ | async}">
  <router-outlet></router-outlet>
</div>
